import { render, staticRenderFns } from "./EylemSkorlari.vue?vue&type=template&id=1ec20dea"
import script from "./EylemSkorlari.vue?vue&type=script&lang=js"
export * from "./EylemSkorlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports